import 'lazysizes';
import objectFitImages from 'object-fit-images';
objectFitImages();

import urijs from 'urijs';
import EventEmitter from 'eventemitter3';
window.gEvent = new EventEmitter();

//import Cookies from 'js-cookie';

//////////////////////////////
// グローバル変数
//////////////////////////////
window.gAMBR = [];
window.gAMBR.rootHTML = document.documentElement;
window.gAMBR.lang = window.gAMBR.rootHTML.lang;
window.gAMBR.mods = [];
window.gAMBR.isDevice = '';
window.gAMBR.isAndroid = false;
window.gAMBR.isEnableTouch = false;
window.gAMBR.isSmoothScroll = true;
window.gAMBR.query = urijs.parseQuery(location.search);

if (gAMBR.lang === 'ja') {
  window.gAMBR.rootPath = '/';
} else {
  window.gAMBR.rootPath = '/en/';
}

const ua = navigator.userAgent.toLowerCase();
if (/iphone|ipad|macintosh|ipod/.test(ua) && 'ontouchend' in document) {
  gAMBR.rootHTML.classList.add('ambr-mobile');
  gAMBR.isDevice = 'mobile';
  gAMBR.isAndroid = false;
} else if (/android/.test(ua) && 'ontouchend' in document) {
  gAMBR.rootHTML.classList.add('ambr-mobile');
  gAMBR.isDevice = 'mobile';
  gAMBR.isAndroid = true;
} else {
  gAMBR.rootHTML.classList.add('ambr-pc');
  gAMBR.isDevice = 'pc';
  gAMBR.isAndroid = false;
}

if(window.ontouchstart !== undefined && 0 < navigator.maxTouchPoints) {
  gAMBR.isEnableTouch = true;
}

history.scrollRestoration = 'manual';

/*
if (ua.indexOf('windows') !== -1 ) {
  gAMBR.isSmoothScroll = true;
}
*/

window.delay = (n) => {
  n = n || 2000;
  return new Promise((done) => {
    setTimeout(() => {
      done();
    }, n);
  });
};
